import {Controller} from "@hotwired/stimulus";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        isInvalid: Boolean,
        invalidFeedback: String,
    }

    invalidFeedbackElement = null;

    isInvalidValueChanged(isInvalid) {
        if (isInvalid) {
            this.element.classList.add('is-invalid');
        } else {
            this.element.classList.remove('is-invalid');
        }
    }

    invalidFeedbackValueChanged(invalidFeedback) {
        if (invalidFeedback) {
            if (null === this.invalidFeedbackElement) {
                this.invalidFeedbackElement = document.createElement('div');
                this.invalidFeedbackElement.classList.add('invalid-feedback');
                this.element.insertAdjacentElement('afterend', this.invalidFeedbackElement);
            }

            this.invalidFeedbackElement.innerText = invalidFeedback;
        } else {
            if (this.invalidFeedbackElement) {
                this.invalidFeedbackElement.remove();
                this.invalidFeedbackElement = null;
            }
        }
    }
}
